import { Ikon } from '@studio/design-system/button';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { ZoomProps } from './types.js';

/** `<Zoom>` component. */
export const Zoom = ({ className, movement, ...props }: ZoomProps): ReactElement => (
  <Ikon
    className={twMerge(
      'w-40 rounded bg-base-100 text-xl active:bg-primary active:text-light',
      className
    )}
    data-movement={movement}
    {...props}
  />
);
